module.exports = __webpack_public_path__ + "img/buy.a2d52d61.png";